import { GridLayout, ParticipantTile } from '@livekit/components-react'
import { Room } from 'livekit-client'
import useMuseTracks from './useMuseTracks'

type Props = {
    room: Room
    hostUserId: string
}

const MuseGridLayout = ({ room, hostUserId }: Props) => {
    const museTracks = useMuseTracks(room, hostUserId)

    return (
        <div className="w-screen h-screen overflow-hidden">
            <GridLayout tracks={museTracks.all}>
                <ParticipantTile />
            </GridLayout>
        </div>
    )
}

export default MuseGridLayout
